<template>
  <div class="maks">
    <div class="messageBox">
      <div class="boxTop"><span class="title"></span><span class="close"><a-icon type="close" /></span></div>
      <div class="content">
        <p class="text">{{ orderText }}</p>
        <p class="text">
          <span>取消类型</span> 
          <a-radio-group v-model="cancelType" name="radioGroup">
            <a-radio :value="cancelTypeList.CANCEL_ALL">
              全部取消
            </a-radio>
            <a-radio v-if="canCancelDeliver" :value="cancelTypeList.CANCEL_DELIVER">
              仅取消运输
            </a-radio>
          </a-radio-group>
        </p>
      </div>
      <div class="button">
        <a-button @click="onClose">取消</a-button>
        <a-button type="primary" @click="onUpdate">确定</a-button>
      </div>
    </div>
  </div>
</template>

<script>
const cancelTypeList = {
  CANCEL_ALL: 'CANCEL_ALL',
  CANCEL_DELIVER: 'CANCEL_DELIVER'
}

export default {
  name: 'MessageBox',
  props: {
    orderList: {
      type: Array,
      default: ()=>[],
    },
    canCancelDeliver: {
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      cancelTypeList,
      cancelType: 'CANCEL_ALL'
    }
  },
  computed:{
    orderText(){
      const num = this.orderList.length
      return num > 1 ? `确定取消选中的${ num } 个订单` : `确定取消订单${ this.orderList[0] }`
    }
  },
  methods: {
    onClose() {
      this.$emit('onClose')
    },
    onUpdate() {
      this.$emit('onUpdate', this.cancelType)
    }
  }
}
</script>
<style lang="less" scoped>
.maks{
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2005;
  background: rgba(0, 0, 0, 0.65);
}
.messageBox{
  width: 420px;
  min-height: 100px;
  padding: 15px;
  background-color: #fff;
  border-radius: 5px;
  .boxTop{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .content{
    padding: 15px 30px;
    .text{
      line-height: 30px;
      font-size: 14px;
      span{
        margin-right: 20px;
      }
    }
  }
  .button{
    text-align: right;
    button{
      margin-left: 20px;
    }
  }
}
</style>
